import React, { useEffect, useState } from 'react';
import ServicesCard from './ServicesCard';

const Services = () => {
   const [services, setServices] = useState([])
   useEffect(() => {
      fetch('https://car-solution-server.vercel.app/services')
         .then(res => res.json())
         .then(data => setServices(data))
   }, [services])
   return (
      <div id='services' className='mb-24 lg:w-[1024px] xl:w-[1280px] 2xl:w-[1740px] mx-auto'>
         <div className='py-10 lg:w-[640px] mx-auto' data-aos="zoom-in-up" data-aos-duration="2000">
            <h4 className='font-bold text-error text-lg'>Services</h4>
            <h1 className="text-5xl font-bold text-white">Our Service Area</h1>
            <p className='text-xl text-white mt-3'>The majority have suffered alteration in some form, by injected humour, or Randomized words which don't look even slightly believable. </p>
         </div>
         <div className='grid lg:grid-cols-3'>
            {
               services.map(service => <ServicesCard
                  key={service._id}
                  service={service}
               ></ServicesCard>)
            }
         </div>
         <button className="btn btn-outline btn-error">More Services</button>
      </div>
   );
};

export default Services;